import PhotoGallery from "./photoGallery";
export default PhotoGallery;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/photoGallery/index.ts
// module id = k6Fy
// module chunks = 2